<template>
  <div class="header" :style="headerStyle">
    <div class="header-list">
      <div class="header-top">
        <div class="logo">
          <a class="logo-white" v-if="isNavTop" href="/"></a>
          <a class="logo-blue" v-else href="/"></a>
        </div>
        <ul class="header-menu">
          <li v-for="(item,index) in headerList" :key="index">
            <a :style="{'--color': menuStyle.color,'--hover-color': menuStyle.hoverColor}"
               @mouseover="handleMouseEnter(item?.path)"
               @click="handlerClick(item?.path)">{{ item?.title || '' }}
            </a>
          </li>
        </ul>
        <div class="header-menu-right">
          <!--          <div v-show="!isShowSearchView" class="header-menu-right-language-button"-->
          <!--               :style="{'&#45;&#45;color': menuStyle.color,'&#45;&#45;hover-color': menuStyle.hoverColor}">-->
          <!--            <div @click="toggleLanguage">English(EN)</div>-->
          <!--          </div>-->
          <ul v-show="!isShowSearchView">
            <li v-for="(item,index) in headerRights" :key="index">
              <router-link :style="{'--color': menuStyle.color,'--hover-color': menuStyle.hoverColor}"
                           :to="item?.path"
                           @mouseover="handleMouseEnter(item?.path)"
                           @click="handlerClick(item?.path)">{{ item?.title || '' }}

              </router-link>
            </li>
            <li v-if="false">
              <a href="https://en.yiconmed.com" target="_blank" rel="noopener noreferrer"
                 :style="{'--color': menuStyle.color,'--hover-color': menuStyle.hoverColor}"
                 @mouseover="handleMouseEnter('')">EN</a>
            </li>
          </ul>
          <div class="search-icon" :style="{'--color': menuStyle.color,'--hover-color': menuStyle.hoverColor}"
               @click="onClickSearch"></div>
        </div>
        <SearchSubView class="header-search" :isShowSearchView="isShowSearchView"
                       @send-search-data="fromSearchSubViewData"/>
      </div>
    </div>
    <PlatformSubView v-show="isShowPlatformView" @send-platform-data="fromPlatformSubViewData"/>
    <TopicSubView v-show="isShowTopicView" @send-topic-data="fromTopicSubViewData"/>
  </div>
</template>

<script setup>

import router from "@/router/router.js"
import PlatformSubView from "@/views/platform/PlatformSubView.vue"
import store from "@/store/index.js"
import SearchSubView from "@/components/common/SearchSubView.vue"
import TopicSubView from "@/views/topic/TopicSubView.vue";

// 使用 computed 来响应式计算菜单项
const headerList = computed(() => {
  return [
    {title: '首页', path: '/home'},
    {title: '关于我们', path: '/about'},
    {title: '技术服务平台', path: '/platform/service'},
    {title: '中心实验室', path: '/center/lab'},
    {title: '专题', path: '/topic'},
    {title: '网络课堂', path: '/videos'},
    {title: '新闻中心', path: '/news'},
    {title: '人工智能问答', path: '/ai-consult'}
  ]
})

let isShowPlatformView = ref(false)
let isShowTopicView = ref(false)
let isShowSearchView = ref(false)

const fromPlatformSubViewData = (data) => {
  isShowPlatformView.value = data; // 更新父组件的数据
}

const fromSearchSubViewData = (data) => {
  isShowSearchView.value = data; // 更新父组件的数据
}

const fromTopicSubViewData = (data) => {
  isShowTopicView.value = data; // 更新父组件的数据
}

const toggleLanguage = () => {
  // todo 切换英文版
  // router.push({name: 'videoList'})
}

const handlerClick = (path) => {
  router.push({path: path})
  store.commit('setNewsCurrentPage', 1)
}

const handleMouseEnter = (path) => {
  if (path === '/platform/service') {
    isShowPlatformView.value = true
    isShowTopicView.value = false
    store.commit('setTopicTab', 0)
  } else if (path === '/topic') {
    isShowTopicView.value = true
    isShowPlatformView.value = false
    store.commit('setPlatformTab', 0)
  } else {
    store.commit('setPlatformTab', 0)
    store.commit('setTopicTab', 0)
    isShowPlatformView.value = false
    isShowTopicView.value = false
  }
}

const onClickSearch = () => {
  isShowSearchView.value = !isShowSearchView.value
}

const headerRights = computed(() => {
  return [
    {title: '联系我们', path: '/contact'}
  ]
})

const props = defineProps({
  isNavVisible: Boolean,
  isNavTop: Boolean
})

const headerStyle = reactive({
  transition: 'transform 0.3s ease',
  transform: '',
  backgroundColor: '',
  boxShadow: '',
})

const menuStyle = reactive({
  transition: 'all 0.3s',
  color: '',
  hoverColor: ''
})

// 监听导航是否可见
watch(() => props.isNavVisible, (newValue) => {
  if (newValue) {
    headerStyle.transform = 'translateY(0)'
    isShowPlatformView.value = false
    isShowTopicView.value = false
  } else {
    headerStyle.transform = 'translateY(-100%)'
  }
}, {immediate: true})

// 监听导航是否到顶
watch(() => props.isNavTop, (newValue) => {
  if (newValue) {
    headerStyle.backgroundColor = 'transparent'
    headerStyle.boxShadow = 'none'
    menuStyle.color = '#fff'
    menuStyle.hoverColor = 'var(--main-sub-color)'

  } else {
    headerStyle.backgroundColor = '#fff'
    headerStyle.boxShadow = '1px 1px 10px rgba(0, 0, 0, 0.1)'
    menuStyle.color = 'var(--main-color)'
    menuStyle.hoverColor = 'var(--main-sub-color)'
  }
}, {immediate: true})

</script>

<style scoped>
.header {
  position: fixed;
  width: 100%;
  color: white;
  z-index: 1000; /* 确保 header 在最上层 */
}

.header-top {
  width: 100%;
  height: 80px;
  margin-left: -41px;
  display: flex;
}

.logo {
  display: flex;
  height: 100%;
}

.logo-white {
  margin-left: 75px;
  margin-right: 75px;
  width: 160px;
  height: 80px;
  margin-top: 5px;
  align-items: center;
  display: inline-block;
  background-image: url("@/assets/images/logo_white.webp");
  background-size: contain;
  background-repeat: no-repeat;
}

.logo-blue {
  width: 346px;
  height: 158px;
  padding-top: 5px;
  display: inline-block;
  background: url("@/assets/images/logo.png") no-repeat 0 -20px;
  background-size: cover;
}

.header-top ul {
  height: 80px;
  list-style-type: none;
  flex: 1;
  display: flex;
  letter-spacing: 2px;
  align-items: center;
}

.header-top ul li {
  margin: 0 25px;
  font-size: 17px;
  cursor: pointer;
  white-space: nowrap;
}

a {
  display: inline-block;
  font-family: '时尚中黑简体', serif;
  color: var(--color);
  --hover-color: rgba(255, 255, 255, 0.3);
  letter-spacing: 2px;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
}

.header-top ul li a:hover {
  color: var(--hover-color);
  transform: scale(1.1);
}

.header-menu-right {
  position: relative;
  display: flex;
  float: right;
  height: 80px;
  margin-right: 86px;
  list-style-type: none;
  letter-spacing: 1px;
  align-items: center;
}

.header-search {
  position: absolute;
  right: 0;
  top: -10px;
  margin-right: 165px;
}

.header-menu-right-language-button {
  margin-right: 30px;
  font-family: '时尚中黑简体', serif;
  letter-spacing: 2px;
  color: var(--color);
  font-size: 17px;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;

  :hover {
    color: var(--hover-color);
    transform: scale(1.1);
  }
}

.header-menu-right ul li a {
  display: inline-block;
  letter-spacing: 2px;
  color: var(--color);
  font-size: 17px;
  font-family: '时尚中黑简体', serif;
  --hover-color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;

  :hover {
    color: var(--hover-color);
    transform: scale(1.1);
  }
}

.search-icon {
  width: 28px;
  height: 28px;
  margin-left: 30px;
  background-color: var(--color);
  mask-image: url("@/assets/images/ic_search.png");
  mask-size: cover;
  mask-repeat: no-repeat;
  mask-position: center;
  --hover-color: rgba(255, 255, 255, 0.3);
  transition: transform 0.3s ease, color 0.3s ease;
}

.search-icon:hover {
  background-color: var(--hover-color);
  transform: scale(1.1);
  cursor: pointer;
}

</style>
